export const BACKEND_URL = 'http://localhost:8000/api/v1'

export const CERTIFICATE_READ_SCOPE = 'certificaten:read'
export const CERTIFICATE_WRITE_SCOPE = 'certificaten:write'
export const CERTIFICATE_ORGANIZATION_SWITCH_SCOPE = 'certificaten:organization_switch'
export const CERTIFICATE_ORGANIZATION_WRITE_SCOPE = 'certificaten:organization_write'

export const CERTIFICATE_SCOPES = [
  CERTIFICATE_READ_SCOPE,
  CERTIFICATE_WRITE_SCOPE,
  CERTIFICATE_ORGANIZATION_SWITCH_SCOPE,
  CERTIFICATE_ORGANIZATION_WRITE_SCOPE
]

export const scopes = CERTIFICATE_SCOPES.join(' ')
